const puzzle = {
  id: "P9Zx7jwlpeiU3efeOzVl",
  name: "A Traveling Icon",
  rebuses: [
    {
      solutionInfo: {
        type: "text",
        solvedText: "The Office",
        possibleSolutions: [
          {
            value: "The Office",
            id: "03b34cfb-b76a-4bfa-a79a-c1998fd81cf6",
          },
          {
            value: "Office",
            id: "4350eaf4-3d1e-455a-ada9-be4898418a01",
          },
        ],
      },
      id: "860dfe75-1868-4c12-879d-bd9db2857f12",
      clues: [
        {
          helperText:
            "Find the painting and write in the number of people for every painting.",
          id: "b6fa29ee-bc99-4336-8e53-70dd681ae25b",
          clueGroup: 0,
          clueValues: [
            {
              type: "customComponent",
              subtext: "",
              value: "OfficeCounterXCoordinate",
              id: "928b956d-0474-4681-abbc-8a7d043824c4",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          dependsOn: [],
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                value: "",
                id: "6dc61916-da4e-4573-bd4f-8505b5f54a5b",
              },
            ],
            type: "customComponent",
            solvedText: "",
          },
          style: {
            width: "calc(50% - 10px)",
          },
        },
        {
          helperText: "Solve the Sudoku and type in highlighted numbers.",
          dependsOn: [],
          clueGroup: 0,
          solutionInfo: {
            type: "customComponent",
            possibleSolutions: [
              {
                value: "",
                id: "c27e0d55-6809-42ef-bb11-0489ad1d461c",
              },
            ],
            solvedText: "",
          },
          subtext: "",
          clueValues: [
            {
              type: "customComponent",
              id: "19774a69-da91-4d0d-9911-647f275d4dec",
              subtext: "",
              value: "OfficeYCoordinateSudoku",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          style: {
            width: "calc(50% - 10px)",
          },
          id: "63facaec-5ea8-4705-89bd-8c58d1865cd5",
        },
        {
          helperText: "Find out which TV Show was filmed at those coordinates.",
          clueValues: [
            {
              type: "image",
              subtext: "34.210732, -118.436535",
              id: "eab77e0a-77b6-4343-96fb-de455b06d780",
              style: {
                width: "calc(50% - 10px)",
              },
              value: "RL7Vmm5S.png",
            },
          ],
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          dependsOn: [
            {
              id: "4665b28c-422b-4553-9a7a-086ebeac48b0",
              value: "63facaec-5ea8-4705-89bd-8c58d1865cd5",
            },
            {
              value: "b6fa29ee-bc99-4336-8e53-70dd681ae25b",
              id: "8225f7f6-c606-4b3a-8d1d-ebb308f753cb",
            },
          ],
          subtext: "TV Show filmed at that location",
          style: {
            width: "calc(50% - 10px)",
          },
          clueGroup: 0,
          id: "baac11cc-22a2-4a44-9e23-1a983d7abe1a",
        },
      ],
      style: {},
    },
    {
      clues: [
        {
          helperText:
            "Find international maritime signal flags and corresponding letters.",
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              subtext: "",
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "bOxmuVq6.png",
              id: "100bb61e-b34a-4132-8deb-db237669b10c",
            },
          ],
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                value: "Launch",
                id: "698f1ac5-7117-4463-893f-d83564f6acd9",
              },
            ],
            solvedText: "Launch",
            type: "text",
          },
          clueGroup: 0,
          id: "ab8c1c65-ca72-47e6-962b-0d59b17fdbe1",
        },
        {
          solutionInfo: {
            type: "text",
            solvedText: "Party",
            possibleSolutions: [
              {
                value: "Party",
                id: "b8c6f1b2-f478-4343-916f-1090b734a3c4",
              },
            ],
          },
          style: {
            width: "calc(33% - 10px)",
          },
          id: "c78d9571-c507-4080-8084-c6b28fe2eb32",
          subtext: "",
          clueValues: [
            {
              type: "image",
              subtext: "",
              id: "83f48aea-ba5f-4c24-97fb-53db25799135",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "AeUdbpIb.png",
            },
          ],
          helperText: "Find a Braille Alphabet and type in correct letters.",
          dependsOn: [],
          clueGroup: 0,
        },
      ],
      id: "d3698f43-8e8d-47b2-a996-e47e1cbe62c1",
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [],
        solvedText: "Launch Party",
      },
    },
    {
      style: {},
      id: "fb5998b2-4095-4858-bc29-62540a90c03d",
      solutionInfo: {
        possibleSolutions: [
          {
            id: "2483eebf-6569-48d8-8e33-739a24b93a8f",
            value: "Intro",
          },
          {
            value: "Intro song",
            id: "d14c2d0d-95e2-44de-b83a-3f385b51fb65",
          },
          {
            value: "Introduction",
            id: "100871b8-5f87-4d09-9b8c-3ba24a1b9f9d",
          },
        ],
        solvedText: "Intro",
        type: "text",
      },
      clues: [
        {
          dependsOn: [],
          clueGroup: 0,
          subtext: "",
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          clueValues: [
            {
              id: "0ed70623-6aaf-4b04-ba8c-bb5189db1f96",
              subtext: "Friends",
              value: "The Rembrands - I'll be there for you",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "c3ba32cb-b43d-405b-941f-d4cbb0ceef63",
          helperText: "What is this song to the TV Show Friends?",
          style: {
            width: "calc(33% - 10px)",
          },
        },
        {
          id: "a06e0a23-2f24-4e13-b0bb-2c0074690cb7",
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          style: {
            width: "calc(33% - 10px)",
          },
          helperText: "What is this song to the TV Show Malcolm In The Middle?",
          clueValues: [
            {
              value: "They Might Be Giants - Boss of me",
              id: "00150b18-c5fd-4fe8-8a9d-c5e306ac4478",
              subtext: "Malcolm In The Middle",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          clueGroup: 0,
          subtext: "",
        },
        {
          style: {
            width: "calc(33% - 10px)",
          },
          id: "0edfdcce-6245-4922-b410-f42f5827c5de",
          clueValues: [
            {
              id: "17a618ef-4aa5-4d91-bc20-4adfa4fb1806",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "Community",
              type: "text",
              value: "The 88 - At Least It Was Here",
            },
          ],
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          helperText: "What is this song to the TV Show Community?",
          clueGroup: 0,
          dependsOn: [],
          subtext: "",
        },
        {
          id: "6cc3479f-89d0-43a4-bda0-9cee8bcc55ca",
          dependsOn: [],
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          helperText: "",
          clueValues: [
            {
              id: "e80ff1df-b0f7-49e0-b708-60a135ef53a6",
              value: "Synonims: prologue, opening, foreword",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              subtext: "",
            },
          ],
        },
      ],
    },
    {
      style: {},
      solutionInfo: {
        type: "text",
        solvedText: "DVD Video",
        possibleSolutions: [
          {
            value: "DVD Video",
            id: "80eadc8a-7286-4abb-bfef-0709b27ccc93",
          },
          {
            value: "DVD",
            id: "31389cb3-6c37-4403-a5a5-f34cd1ab994f",
          },
        ],
      },
      id: "6d5ba430-5d67-4b47-9907-2e81004fc1cc",
      clues: [
        {
          clueGroup: 1,
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
          clueValues: [
            {
              subtext: "",
              type: "text",
              id: "585a1cdd-2c90-48d2-90dd-a92749dcf0bd",
              value: "The Office",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "",
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          id: "d1af8877-dc18-4b4b-aef7-1525a14852cf",
        },
        {
          subtext: "",
          helperText: "",
          dependsOn: [],
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          id: "c8f71554-9e1f-48ed-a3e4-0f1cdc09e6e4",
          clueValues: [
            {
              type: "text",
              value: "Launch Party",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "9dfda4f7-32b7-46e6-be9a-600293bab27b",
              subtext: "Episode name",
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
          clueGroup: 1,
        },
        {
          style: {
            width: "calc(33% - 10px)",
          },
          clueGroup: 1,
          subtext: "",
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          clueValues: [
            {
              id: "f599b5e2-2e9f-4462-9b3e-73d0a918c6d4",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              value: "Intro",
            },
          ],
          id: "0d27d365-2883-44a1-8b4d-fda6569dbee1",
          helperText: "",
          dependsOn: [],
        },
        {
          subtext: "",
          dependsOn: [],
          helperText:
            "What Icon is displayed on the screen of a given object in intro scene of the episode Launch Party (S04E03) of TV Show The Office?.",
          clueGroup: 0,
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          id: "3008c4cd-8d69-416d-bf00-c411b47c0a4a",
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "0ac5fdb3-633d-4dd2-8e8d-26cb3ea38640",
              value: "wd5FiZUj.png",
              subtext: "Icon",
            },
          ],
        },
      ],
    },
  ],
};
export default puzzle;
